import {
    DOWNLOAD_CUSTOMER_CSV_FAILURE,
    DOWNLOAD_CUSTOMER_CSV,
    DOWNLOAD_CUSTOMER_CSV_SUCCESS,
    SET_CUSTOMERS,
    SET_CUSTOMER_DETAILS,
    GET_CUSTOMER_TRANSACTION,
    GET_CUSTOMER_TRANSACTION_SUCCESS,
    GET_CUSTOMER_TRANSACTION_FAILURE
} from './actionTypes';

const initialState = {
    customers: null,
    loadingCustomer: true,
    customerDetails: {},
    downloadedCustomer: '',
    error: '',
    loading: false,
    customerTransaction: null
};

const Customers = (state = initialState, action) => {
    switch (action.type) {
        case SET_CUSTOMER_DETAILS:
            state = { ...state, customerDetails: action.payload };
            break;
        case SET_CUSTOMERS:
            state = { ...state, customers: action.payload, loadingCustomer: false };
            break;
        case DOWNLOAD_CUSTOMER_CSV:
            state = { ...state, loading: true };
            break;
        case DOWNLOAD_CUSTOMER_CSV_SUCCESS:
            state = { ...state, loading: false, downloadedCustomer: action.payload };
            break;
        case DOWNLOAD_CUSTOMER_CSV_FAILURE:
            state = { ...state, loading: false, error: action.payload };
            break;
        // case GET_CUSTOMER_TRANSACTION:
        //     state = { ...state, loading: true };
        //     break;
        case GET_CUSTOMER_TRANSACTION_SUCCESS:
            state = { ...state, customerTransaction: action.payload };
            break;
        case GET_CUSTOMER_TRANSACTION_FAILURE:
            state = { ...state, loading: false, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default Customers;
